/* import __COLOCATED_TEMPLATE__ from './public-top-nav.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { inject as service } from '@ember/service';

export default Component.extend({
  intercomEventService: service(),
  classNames: ['appstore__public-top-nav'],
  appstoreService: service(),
  media: service(),
  actions: {
    trackClick(object) {
      this.intercomEventService.trackAnalyticsEvent({
        action: 'clicked',
        object,
        location: 'top_nav',
      });
    },
    redirectToSignIn() {
      this.send('trackClick', 'log_in_link');
      this.appstoreService.redirectToWorkspaceAppstore();
    },
  },
});
